export function HandleResponse(response) {
    let result = {
        value: response?.results || [],
        pageData: {
            pageSize: response?.pageSize || 1,
            pageCount: response?.pageCount || 0,
            currentPage: response?.currentPage || 1,
        },
        total: parseInt(response?.rowCount, 10) || 0
    }

    if (response?.errorCode === 1) {
        result.errorMessage = response.message
    }

    return result;
}

export function HandleResponseDiocese(response, type = "") {
    let result = {
        status: response?.status || '',
        message: response?.message || '',
        statusCode: response?.statusCode || 0
    };

    if (!result.status) {
        return result;
    }

    result = {
        value: response?.payload?.data || [],
        pageData: {
            currentPage: response?.payload?.page || 1,
            pageSize: response?.payload?.pageSize || 10,
            pageCount: response?.payload?.totalRecords || 0,
        },
        total: parseInt(response?.rowCount, 10) || 0
    }

    if (response?.errorCode === 1) {
        result.errorMessage = response.message
    }

    return result;
}
